import PIPELINE_STEPS from '../../../../utils/pipeline_steps';
import ColumnActionModel from './column_action_model';
import TableModel from "../../../datasource/table";

export default class HideColumnStepModel extends ColumnActionModel {
    name = 'Hide Column';
    type = PIPELINE_STEPS.HIDE_COLUMN;
    isSaved = true;

    apply(table) {
        if (table.columns.length <= 1) {
            return {table, error: true};
        }
        const newTable = new TableModel(table);
        newTable.removeColumn(this.columnId);
        return {table: newTable};
    }
}
